<template>
  <div>
    <div class="reappro reappro--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <ReapproHeader :detail="true" :item="this.detail"></ReapproHeader>
      <ProductFamilyList class="categories--reappro"></ProductFamilyList>
      <div class="reappro__products" v-if="this.detail.status == 0">
        <ProductReappro :item="item" v-for="item in this.detail.lines" :detail="true" :key="item.id" :update="true">
        </ProductReappro>
      </div>
      <div class="reappro__products" v-else-if="this.detail.status == 3">
        <ProductReappro :item="item" v-for="item in this.detail.lines" :detail="true" :key="item.id" :update="true"
          :showQuantity="'shipped'"></ProductReappro>
      </div>
      <div class="reappro__products" v-else-if="this.detail.status >= 4">
        <ProductReappro :item="item" v-for="item in this.detail.lines" :detail="true" :key="item.id" :update="false"
          :showQuantity="'received'"></ProductReappro>
      </div>
      <div class="reappro__products" v-else>
        <ProductReappro :item="item" v-for="item in this.detail.lines" :detail="true" :key="item.id" :update="false"
          :showQuantity="'validated'"></ProductReappro>
      </div>
    </div>
  </div>
</template>

<script>

import ReapproHeader from "@/components/Reappro/ReapproHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import ProductReappro from "@/components/Product/ProductReappro";

export default {
  name: "ReapproDetail",
  data() {
    return {
      detail: {
        id: null,
      }
    };
  },
  created(){
    this.$store.dispatch('showLoader');
  },
  mounted() {
    const self = this;
    this.$store.dispatch("order/getItem", {id: this.$route.params.id}).then(() => {
      this.detail = this.$store.getters["order/getItem"](
        this.$route.params.id
      );

      this.$store.dispatch('hideLoader');
    });
  },
  methods: {

  },
  components: {
    ReapproHeader,
    ProductFamilyList,
    ProductReappro,
  }
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.reappro {
  display: flex;

  &--mobile {
    flex-direction: column;

    .reappro__products {
      padding: 20px;
    }

    .imputation__text {
      margin-right: 5px;
    }

    .product {
      .imputation__selector {
        margin-left: 0;
      }
    }
  }
}

.reappro__btns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 20px;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 75px;
  z-index: 19;

  .reappro__btn {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 75px;
    color: white;
    outline: none;
    border-radius: 0;
    padding: 0 20px;

    img {
      width: 25px;
      margin-left: 5px;
      margin-left: 15px;
    }

    span {
      font-size: 11px;
      font-family: 'ClanPro';
      flex: 1;
      text-align: left;
    }

    &.btn--valider {
      background-color: $vert;
      justify-content: space-between;
      align-items: center;
    }

    &.btn--delete {
      background-color: $color1;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproDetail.vue